
const defaultReducer =  (key, initialState) => {
	return (state = initialState, action) => {
		switch (action.type) {
			case key:
				return typeof action.payload === "string" ? action.payload : {...state, ...action.payload} ;
			default:
				return state;
		}
	}
}

const initialState = { 
	grid: { data:[], headerDef:[], rowDef:[], pageCount: 1, pageNumber: 1 },
	summary: { data:[], headerDef:[], rowDef:[] },
	showSummary: false,
}

export const transactionsReducer = defaultReducer('FETCH_TRANSACTIONS', initialState);
export const transactionsTicketsReducer = defaultReducer('TRANSACTION_TICKETS', initialState);
export const transactionsKioskReducer = defaultReducer('TRANSACTIONS_KIOSK', initialState);

export const transactionAdjustReducer = defaultReducer('SET_TRANSACTION_ADJUST', "");
export const transactionAuthoriseReducer = defaultReducer('SET_TRANSACTION_AUTHORISE', "");
export const transactionVoidReducer = defaultReducer('SET_TRANSACTION_VOID', "");
